module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lista-solicitud-vacaciones contenedor-interno"
  }, [_vm._m(0), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "filtros-container",
    staticClass: "filtros-container"
  }, [_c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "title-filtro",
    staticClass: "title-filtro",
    class: {
      'hide-box-shadow': !_vm.mostrarFiltros
    },
    on: {
      "click": function($event) {
        _vm.mostrarFiltros = !_vm.mostrarFiltros
      }
    }
  }, [_c('h2', {
    staticClass: "text"
  }, [_vm._v("filtros")]), _c('div', {
    staticClass: "caret"
  }, [_c('span', {
    staticClass: "icon"
  }, [(_vm.mostrarFiltros) ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _c('i', {
    staticClass: "fa fa-caret-up"
  })])])]), (_vm.mostrarFiltros) ? _c('div', {
    key: "filtros",
    staticClass: "filtros"
  }, [_c('div', {
    staticClass: "columns is-multiline display-flex"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "codigo-empleado"
  }, [_c('div', {
    staticClass: "control title-singular"
  }, [_c('p', [_vm._v("Alumno")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.codigoEmpleado),
      expression: "filtros.codigoEmpleado"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.filtros.codigoEmpleado)
    },
    on: {
      "focus": function($event) {
        _vm.mostrarBusquedaEmpleado = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "codigoEmpleado", $event.target.value)
      }
    }
  }), _c('span', {
    staticClass: "icon cursor-pointer margin-left-5",
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaEmpleado = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _c('div', {
    staticClass: "erase-data",
    on: {
      "click": function($event) {
        _vm.filtros.codigoEmpleado = ''
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "fa fa-times"
  })])])])]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaEmpleado) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-small-empleado', {
    attrs: {
      "codigo": _vm.filtros.codigoEmpleado
    },
    on: {
      "selected": _vm.seleccionarEmpleado,
      "close": function($event) {
        _vm.mostrarBusquedaEmpleado = false
      }
    }
  })], 1) : _vm._e()])], 1)])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Curso")])]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.idCurso),
      expression: "filtros.idCurso"
    }],
    staticClass: "flex-1",
    attrs: {
      "disabled": _vm.isLoadingCursos
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "idCurso", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.changeFiltroCurso]
    }
  }, [_c('option', {
    domProps: {
      "value": ''
    }
  }, [_vm._v("Todos")]), _vm._l((_vm.cursos), function(o) {
    return _c('option', {
      domProps: {
        "value": o.id
      }
    }, [_vm._v(_vm._s(_vm._f("truncateText")(o.titulo, 20)))])
  })], 2)])])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Clase")])]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.idClase),
      expression: "filtros.idClase"
    }],
    staticClass: "flex-1",
    attrs: {
      "disabled": _vm.isLoadingClases || _vm.isLoadingCursos
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "idClase", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.changeFiltro]
    }
  }, [_c('option', {
    domProps: {
      "value": ''
    }
  }, [_vm._v("Todos")]), _vm._l((_vm.clases), function(o) {
    return _c('option', {
      domProps: {
        "value": o.id
      }
    }, [_vm._v(_vm._s(_vm._f("truncateText")(o.titulo, 20)))])
  })], 2)])])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v(_vm._s('Activo(curso)'))])]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.activoCurso),
      expression: "filtros.activoCurso"
    }],
    staticClass: "flex-1",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "activoCurso", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.changeFiltro]
    }
  }, [_c('option', {
    domProps: {
      "value": ''
    }
  }, [_vm._v("Todos")]), _c('option', {
    domProps: {
      "value": '1'
    }
  }, [_vm._v("Sí")]), _c('option', {
    domProps: {
      "value": '0'
    }
  }, [_vm._v("No")])])])])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v(_vm._s('Activo(clase)'))])]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.activoClase),
      expression: "filtros.activoClase"
    }],
    staticClass: "flex-1",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "activoClase", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.changeFiltro]
    }
  }, [_c('option', {
    domProps: {
      "value": ''
    }
  }, [_vm._v("Todos")]), _c('option', {
    domProps: {
      "value": '1'
    }
  }, [_vm._v("Sí")]), _c('option', {
    domProps: {
      "value": '0'
    }
  }, [_vm._v("No")])])])])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Desde termino clase")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.desdeFechaTermino),
      expression: "filtros.desdeFechaTermino"
    }],
    staticClass: "input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filtros.desdeFechaTermino)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "desdeFechaTermino", $event.target.value)
      }
    }
  })])])])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Hasta termino clase")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.hastaFechaTermino),
      expression: "filtros.hastaFechaTermino"
    }],
    staticClass: "input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filtros.hastaFechaTermino)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "hastaFechaTermino", $event.target.value)
      }
    }
  })])])])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Desde inicio curso")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.desdeInicioCurso),
      expression: "filtros.desdeInicioCurso"
    }],
    staticClass: "input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filtros.desdeInicioCurso)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "desdeInicioCurso", $event.target.value)
      }
    }
  })])])])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Hasta inicio curso")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.hastaInicioCurso),
      expression: "filtros.hastaInicioCurso"
    }],
    staticClass: "input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filtros.hastaInicioCurso)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "hastaInicioCurso", $event.target.value)
      }
    }
  })])])])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Desde ver curso")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.desdeVerCurso),
      expression: "filtros.desdeVerCurso"
    }],
    staticClass: "input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filtros.desdeVerCurso)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "desdeVerCurso", $event.target.value)
      }
    }
  })])])])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Hasta ver curso")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.hastaVerCurso),
      expression: "filtros.hastaVerCurso"
    }],
    staticClass: "input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filtros.hastaVerCurso)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "hastaVerCurso", $event.target.value)
      }
    }
  })])])])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Estado del curso del alumno")])]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.estadoCursoAlumno),
      expression: "filtros.estadoCursoAlumno"
    }],
    staticClass: "flex-1",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "estadoCursoAlumno", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.changeFiltro]
    }
  }, [_c('option', {
    domProps: {
      "value": ''
    }
  }, [_vm._v("Todos")]), _c('option', {
    domProps: {
      "value": '1'
    }
  }, [_vm._v("Terminado")]), _c('option', {
    domProps: {
      "value": '2'
    }
  }, [_vm._v("En progreso")]), _c('option', {
    domProps: {
      "value": '0'
    }
  }, [_vm._v("Sin empezar")])])])])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Estado de la clase del alumno")])]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.estadoClaseAlumno),
      expression: "filtros.estadoClaseAlumno"
    }],
    staticClass: "flex-1",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "estadoClaseAlumno", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.changeFiltro]
    }
  }, [_c('option', {
    domProps: {
      "value": ''
    }
  }, [_vm._v("Todos")]), _c('option', {
    domProps: {
      "value": '0'
    }
  }, [_vm._v("Sin empezar")]), _c('option', {
    domProps: {
      "value": '1'
    }
  }, [_vm._v("Terminado")])])])])])])]) : _vm._e(), _c('div', {
    key: "boton-container",
    staticClass: "boton-container"
  }, [_c('button', {
    staticClass: "button m-5",
    on: {
      "click": _vm.fetch
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-fw fa-lg"
  })]), _c('span', [_vm._v("Refrescar")])]), _c('button', {
    staticClass: "button m-5",
    on: {
      "click": _vm.limpiarFiltros
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw fa-lg"
  })]), _c('span', [_vm._v("Limpiar")])])])])], 1), _c('div', {
    key: "body",
    staticClass: "body"
  }, [_c('div', {
    staticClass: "information"
  }, [_c('transition-group', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    staticClass: "contenedor-data",
    attrs: {
      "infinite-scroll-disabled": "disabledScrollExecute",
      "infinite-scroll-distance": "2",
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [(_vm.lista.length !== 0) ? _c('table', {
    key: "lista",
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Curso")]), _c('th', [_vm._v("Clase")]), _c('th', [_vm._v("Alumno")])]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table"
    }, [_c('td', {
      class: {
        'is-close': !o.activoCurso
      }
    }, [_c('span', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'id: ' + o.idCurso
      }
    }, [_vm._v(_vm._s(o.tituloCurso)), (o.fechaVerCurso) ? _c('div', {
      staticClass: "chip ver-curso"
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Visto " + _vm._s(_vm._f("formatDateHour")(o.fechaVerCurso)))])]) : _vm._e(), (o.fechaInicioAlumno) ? _c('div', {
      staticClass: "chip iniciado"
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Iniciado " + _vm._s(_vm._f("formatDateHour")(o.fechaInicioAlumno)))])]) : _vm._e(), (o.fechaTerminoCursoAlumno) ? _c('div', {
      staticClass: "chip terminado"
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Terminado " + _vm._s(_vm._f("formatDateHour")(o.fechaTerminoCursoAlumno)))])]) : _vm._e()])]), _c('td', {
      class: {
        'is-close': !o.activoClase
      }
    }, [_c('span', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'id: ' + o.idClase
      }
    }, [_vm._v(_vm._s(o.tituloClase)), (o.fechaTerminoClaseAlumno) ? _c('div', {
      staticClass: "chip terminado"
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Terminado " + _vm._s(_vm._f("formatDateHour")(o.fechaTerminoClaseAlumno)))])]) : _vm._e()])]), _c('td', [_c('div', {
      staticClass: "td-wrapper"
    }, [_c('span', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Empleado: ' + o.dniEmpleado
      }
    }, [_vm._v(_vm._s(o.nombreEmpleado))])])])])
  }), 0)], 1) : _vm._e()])], 1), (_vm.isLoading) ? _c('div', {
    staticClass: "is-loading"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _vm._e(), (_vm.lista.length === 0 && !_vm.isLoading) ? _c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_c('span', {
    staticClass: "has-text-bold"
  }, [_vm._v("No existe información con los filtros definidos")])])]) : _vm._e()])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Reporte de cursos virtuales")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f1a0a80","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_reporte_cursos_virtuales.vue
// module id = 820
// module chunks = 0